import React from 'react';
import clsx from 'clsx';

import styles from '../styles.module.scss';
import tierStyles from './Tier.module.scss';
import {Tick} from '../../../assets';
import {dataMonthly} from './data';
import {useUser} from '../../../hooks/useAuth';

export const TierCards = () => {
  const {isAuth} = useUser();
  return (
    <div className={tierStyles.tiersWrapper}>
      {dataMonthly.map((item) => (
        <TierCard key={item.id} data={item} isAuth={isAuth} />
      ))}
    </div>
  );
};

export const TierCard = ({data, isAuth}) => {
  return (
    <div className={clsx(tierStyles.tier, tierStyles[data.label])}>
      {isAuth && data.label === 'pro' && <div className={tierStyles.popular}>Most Popular</div>}
      <div className={clsx(styles.label, styles[data.label])}>
        <div className={clsx(styles.labelInner, styles[data.label])}>{data.label}</div>
      </div>
      <div className={tierStyles.priceCond}>
        <p className={tierStyles.price}>${data.price}</p>
        <p className={tierStyles.condition}>{data.condition}</p>
      </div>
      <p className={tierStyles.title}>{data.title}</p>
      <div className={tierStyles.deskWrapper}>
        {!isAuth && <div className={tierStyles.button}>Sign Up</div>}
      </div>
      <div className={tierStyles.featuresWrapper}>
        {data.features.map((item) => (
          <div className={tierStyles.feature} key={item.id}>
            {item.check && <Tick />}
            {item.title}
          </div>
        ))}
      </div>
      <div className={tierStyles.modWrapper}>
        <div className={tierStyles.button}>Sign Up</div>
      </div>
    </div>
  );
};
